import React, { useMemo } from "react";
import { Button } from "components/ui/button";
import { ReactComponent as CalendarIcon } from "icons/calendar.svg";
import { ReactComponent as EditIcon } from "icons/edit.svg";
import { ReactComponent as WaterDropIcon } from "icons/water-drop.svg";
import QueueItem from "components/widgets/queue/QueueItem";
import QueueDurationInput from "components/widgets/queue/QueueDurationInput";
import { formatInTimeZone } from "date-fns-tz";
import { IRRIGATION_TIME_ZONE, queueEventId } from "./timeSlots";

const madridDate = (value) => formatInTimeZone(new Date(value), IRRIGATION_TIME_ZONE, "yyyy-MM-dd");

const QueueList = ({
  selectedDate,
  usersInOrder,
  isAddingDuration = false,
  setIsAddingDuration,
  preferences,
  setPreferences,
  durationOptions,
  canCreateQueueEvent = true,
  user_id,
}) => {
  const selectedDay = madridDate(selectedDate);
  const usersForSelectedDate = useMemo(() => usersInOrder
    .filter((user) => madridDate(user.start) === selectedDay)
    .sort((left, right) => new Date(left.start) - new Date(right.start)), [usersInOrder, selectedDay]);
  const currentUserEvent = usersForSelectedDate.find((user) => String(user.user_id) === String(user_id));
  const isUpdating = Boolean(queueEventId(currentUserEvent));

  const isFutureOrToday = selectedDay >= madridDate(new Date());
  const closeEditor = () => setIsAddingDuration(false);

  return (
    <div className="h-fit flex-col flex">
      <div className="mb-2 pt-2 w-full flex gap-x-2 font-medium text-center"><CalendarIcon className="w-6 h-6" />Cola<span className="ml-auto">{new Intl.DateTimeFormat("es-ES", { year: "numeric", month: "2-digit", day: "2-digit", timeZone: IRRIGATION_TIME_ZONE }).format(new Date(selectedDate))}</span></div>
      <ul className="flex flex-col gap-y-1">
        {usersForSelectedDate.length === 0 && <li className="text-center text-gray-500 pb-2">{isFutureOrToday ? "No hay ningún usuario en cola" : "Este día nadie regó."}</li>}
        {usersForSelectedDate.map((user) => <QueueItem user_id={user_id} user={user} key={user.id || user.event_id} />)}
        {isFutureOrToday && (isAddingDuration ? (
          <li className="flex gap-x-1"><QueueDurationInput isAddingDuration={isAddingDuration} setIsAddingDuration={setIsAddingDuration} preferences={preferences} setPreferences={setPreferences} durationOptions={durationOptions} selectedDate={selectedDate} isUpdating={isUpdating} currentUserEvent={currentUserEvent} onSubmit={closeEditor} /></li>
        ) : currentUserEvent ? (
          <li className="gap-y-1 gap-x-2 flex flex-col md:flex-row"><Button size="lg" className="w-full" variant="default" onClick={() => { setPreferences({ duration: currentUserEvent.durationMinutes ?? currentUserEvent.duration }); setIsAddingDuration(true); }}>Modificar turno<EditIcon className="w-5 h-5 ml-2" /></Button></li>
        ) : (
          <li className="gap-2 flex"><Button size="lg" className="w-full" variant="default" disabled={!canCreateQueueEvent} onClick={() => { if (!canCreateQueueEvent) return; setIsAddingDuration(true); }}>{canCreateQueueEvent ? "Quiero regar" : "Sin parcela asignada"}<WaterDropIcon className="w-6 h-6 ml-2" /></Button></li>
        ))}
      </ul>
    </div>
  );
};

export default QueueList;
